// Contact Information
export const CONTACT = {
  phone: '+91-9618377750',
  whatsapp: '+91-9618377750',
  email: 'thetinytimeschildrensnewspaper@gmail.com',
  whatsappLink: 'https://wa.me/919618377750?text=Hi',
  googleFormLink: 'https://forms.google.com/your-form-id', // Replace with actual form
};

// Edition Information
export const EDITIONS = {
  micro: {
    name: 'Micro Edition',
    ageRange: '4-9 years',
    description: 'Fun stories, colorful puzzles, and early learning adventures!',
  },
  macro: {
    name: 'Macro Edition',
    ageRange: '10-15 years',
    description: 'Exciting news, brain teasers, and creative challenges!',
  },
};

// Social Media Links
export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/tinytimes',
  instagram: 'https://instagram.com/tinytimes',
  twitter: 'https://twitter.com/tinytimes',
  youtube: 'https://youtube.com/tinytimes',
};

// Navigation Links
export const NAV_LINKS = [
  { name: 'Home', path: '/', icon: '🏠' },
  { name: 'About', path: '/about', icon: '📖' },
  { name: 'Editions', path: '/editions', icon: '📚' },
  { name: 'Samples', path: '/samples', icon: '👀' },
  { name: 'Gallery', path: '/gallery', icon: '🖼️' },
  { name: 'Videos', path: '/videos', icon: '🎥' },
  { name: 'Subscribe', path: '/subscribe', icon: '🚀' },
  { name: 'Contact', path: '/contact', icon: '💌' },
];

// Color Palette (for JS usage)
export const COLORS = {
  primary: {
    green: '#4CAF50',
    greenLight: '#81C784',
    greenDark: '#388E3C',
  },
  accent: {
    yellow: '#FFD54F',
    orange: '#FF9800',
    blue: '#B3E5FC',
  },
};